import { X, Check } from "@phosphor-icons/react";
import axios from "axios";
import { toast } from "sonner";

const AdminCardLeave = ({ cb, api }) => {
  const theDay = new Date(cb.create_at !== undefined ? cb.create_at : cb.check_in);
  const thisDay = theDay.getDate();
  const nameDay = theDay.toLocaleDateString("en-GB", {
    weekday: "long",
  });

  const handleX = async (e) => {
    e.preventDefault();
    try {
      await axios.delete(api + '/' + cb.id);
      toast.success("Data berhasil di tolak");
      window.location.reload()
    } catch (err) {
      toast.error("Data gagal di tolak");
      console.error("ERROR 505: " + err);
    }
  };
  const handleCheckList = async (e) => {
    e.preventDefault();
    try {
      await axios.put(api, {
        id: cb.id_attendance,
      });
      toast.success("Data berhasil di setujui");
      window.location.reload()
    } catch (err) {
      toast.error("Data gagal di setujui");
      console.error("ERROR 505: " + err);
    }
  };

  return (
    // <div className="p-2 rounded-lg shadow flex gap-6 bg-slate-50">
    //   <div className="px-6 py-2 justify-center items-center flex flex-col text-white bg-green-700 rounded-lg gap-3">
    //     <p className={"text-2xl font-bold "}>{dayToday}</p>
    //     <p className="text-sm font-light">{dayDay}</p>
    //   </div>
    //   {/* BUILD TIME STATUS */}
    //   <div className="pt-1.5 flex justify-between gap-2 flex-col w-full">
    //     <div className="flex justify-evenly ">
    //       <div className="flex flex-col gap-0.5 items-center justify-center">
    //         <p className="text-md font-semibold">
    //           {getIndochinaTime(cb.check_in)}
    //         </p>
    //         <p className="text-xs font-normal text-gray-400">Check In</p>
    //       </div>
    //     </div>
    //     <div className="flex gap-1.5 justify-center items-center">
    //       <MapPin weight="fill" size={16} className="text-green-700" />
    //       <p className="font-semibold whitespace-nowrap text-xs">
    //         {cb.location}
    //       </p>
    //     </div>
    //   </div>
    //   <div className="justify-center items-center flex text-white rounded-lg gap-2">
    //     <div
    //       onClick={handleX}
    //       className={
    //         "text-lg font-extrabold min-w-10 min-h-10 bg-gray-200 text-gray-400 rounded-lg flex justify-center items-center "
    //       }
    //     >
    //       <X weight="bold" />{" "}
    //     </div>
    //     <div onClick={handleCheckList} className="text-lg font-extrabold min-w-10 min-h-10 bg-green-700 rounded-lg flex justify-center items-center text-white  ">
    //       <Check weight="bold" />{" "}
    //     </div>
    //   </div>
    // </div>
    <div className="p-2 rounded-lg shadow-lg flex flex-col gap-2 bg-slate-50">
      <div className="flex border-b border-gray-400 justify-between">
        <p className="text-md  font-semibold">{cb.name}</p>
      </div>
      <div className="flex gap-2 w-full">
      <div className="w-full flex flex-col gap-2">
      <div className="flex  justify-center py-2 items-center relative bg-green-700 rounded-lg">
        <div className="bg-slate-50 font-semibold max-h-6 top-0 mt-2 ml-2 absolute left-0 text-xs px-3 flex justify-center items-center rounded-md text-black">
        {cb.type === "S"
            ? "Sick"
            : cb.type === "I"
            ? "Permission"
            : "Dispenasi"}
        </div>
        <div className="w-full justify-center items-center flex flex-col text-white">
          <p className="text-2xl font-bold ">{thisDay}</p>
          <p className="text-sm font-light">{nameDay}</p>
        </div>

      </div>
      <p className="text-xs pt-1 px-2 pb-2 bg-gray-300 h-full text-gray-600 rounded-md">
        {cb.reason}
      </p>
      </div>
      {
        api && (
        <div className="flex flex-col gap-2 justify-center h-full">
            <div onClick={handleCheckList} className="rounded-lg cursor-pointer bg-green-700 w-12 h-12 flex justify-center items-center font-extrabold text-xl text-white">
                <Check weight="bold" />
            </div>
            <div onClick={handleX} className="rounded-lg cursor-pointer bg-gray-300 text-gray-400 w-12 h-12 flex justify-center items-center font-extrabold text-xl ">
                <X weight="bold" />
            </div>
        </div>
        )
      }
      </div>
    </div>
  );
};

export default AdminCardLeave;
